'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name dashboard
   * @description
   *
   */
  angular.module('dashboard', ['ng-webcat', 'app.firedux', 'app.themes', 'app.routes', 'app.filters', 'root']);
})();
angular.module('dashboard').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/detail/detail-root.html',
    '<md-toolbar style="border-top:1px solid #E0E0E0" md-theme="white" class="md-whiteframe-4dp"><form name="searchForm" class="md-toolbar-tools"><md-button ng-disabled="true" class="md-icon-button"><md-icon>search</md-icon></md-button><input required="required" flex="flex" ng-model="$ctrl.$query" style="background:none;border:none;outline:none" placeholder="Search here..." class="md-body-1"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>close</md-icon></md-button></form></md-toolbar><div ng-show="!$ctrl.$query" style="padding:1rem"><div class="md-headline">{{$ctrl.projectId}}<br/><br/></div><div layout="column" layout-align="start end"><div class="md-caption md-hue-2">TOTAL WORK TIME</div><div style="font-weight:300" class="md-headline">{{$ctrl.projectTime | chrono}}</div></div></div><div ng-if="$ctrl.$query" style="padding:1rem"><div layout="row" layout-align="start center"><div style="margin-right:1rem;opacity:0.5" class="md-headline material-icons">search</div><div class="md-headline">{{$ctrl.$query}}</div></div><br/><br/><div layout="column" layout-align="start end"><div class="md-caption md-hue-2">SEARCH QUERY TIME</div><div style="font-weight:300" class="md-headline">{{$ctrl.$sumTimes($ctrl.$query, $ctrl.$entities) | chrono}}</div></div></div><md-divider></md-divider><div ng-if="$ctrl.$entities.length &amp;&amp; entity.time" ng-show="$ctrl.$currentProject === entity.entityId || !$ctrl.$currentProject" ng-repeat="entity in $ctrl.$entities | orderBy: \'time\' : true | filter: {filename:$ctrl.$query}"><div style="padding:1rem"><div class="md-title">{{entity.filename}}</div><div class="md-caption">{{entity.path}}  <br/><br/></div><div layout="column" layout-align="start end"><div style="font-weight:300" class="md-headline">{{entity.time | chrono}}</div></div></div><md-divider></md-divider></div>');
}]);

angular.module('dashboard').run(['$templateCache', function($templateCache) {
  $templateCache.put('root/root.html',
    '<!--wc-dialog(wc-dialog-login="email"\n' +
    'wc-dialog-labels=`{\n' +
    '  title: \'Login\',\n' +
    '  body: \'Hey you stranger!!\'\n' +
    '}`\n' +
    'then="$ctrl.$credentials = $data.credentials")\n' +
    'then\n' +
    '  wc-dialog(\n' +
    '    ng-if="$ctrl.$credentials.password !== \'plop\'"\n' +
    '    wc-dialog-template)\n' +
    '    wc-dialog-template\n' +
    '      p|Poop: {{$ctrl.$credentials}}\n' +
    'catch\n' +
    '  wc-dialog(wc-dialog-template)\n' +
    '      \n' +
    '\n' +
    '\n' +
    '--><wc-ui-params ng-if="$ctrl.$hits &amp;&amp; !$ctrl.$loaded" then="$ctrl.$currentProject = $data.projectId">     </wc-ui-params><div style="height:100vh" layout="column"><fd-ref ng-if="$ctrl.$autoRefresh" fd-ref-path="brackets_logs" fd-ref-query="{\n' +
    '      orderByChild: \'timestamp\',\n' +
    '      startAt: $ctrl.startTime\n' +
    '    }" fd-ref-array="true" then="\n' +
    '      $ctrl.$setHits($data);\n' +
    '      $ctrl.$hits = $data;"></fd-ref><fd-ref ng-if="!$ctrl.$loaded" fd-ref-path="brackets_logs" fd-ref-query="{\n' +
    '      orderByChild: \'timestamp\',\n' +
    '      startAt: $ctrl.startTime\n' +
    '    }" fd-ref-array="true" then="\n' +
    '      $ctrl.$setHits($data);\n' +
    '      $ctrl.$hits = $data;\n' +
    '      $ctrl.$loaded = true;"><before><wc-progress wc-progress-type="linear"></wc-progress></before><catch><wc-toast wc-toast-message="Error loading logs"></wc-toast></catch></fd-ref><md-toolbar style="z-index:3" class="md-whiteframe-8dp"><div class="md-toolbar-tools"><i ng-if="!$ctrl.$currentProject" class="material-icons">timer</i><md-button ng-if="$ctrl.$currentProject" ng-click="$ctrl.$changeProject(\'\')" class="md-icon-button"><md-icon>arrow_back</md-icon></md-button><h2 flex="flex">{{$ctrl.$currentProject}}</h2><md-select ng-show="$ctrl.$loaded" ng-init="$ctrl.$timeSelected = 0.333" aria-label="Choose project" ng-model="$ctrl.$timeSelected" ng-change="$ctrl.$changeTime($ctrl.$timeSelected)" class="md-body-1"><md-option ng-value="0.333">8 hours</md-option><md-option ng-value="0.5">12 hours</md-option><md-option ng-value="1">24 hours</md-option><md-option ng-value="2">2 days</md-option><md-option ng-value="3">3 days</md-option><md-option ng-value="7">7 days</md-option><md-option ng-value="15">15 days</md-option><md-option ng-value="30">30 days</md-option><md-option ng-value="90">90 days</md-option></md-select><md-button ng-if="!$ctrl.$autoRefresh &amp;&amp; $ctrl.$loaded" ng-click="$ctrl.$loaded = false" class="md-icon-button"><md-icon>refresh</md-icon></md-button></div></md-toolbar><md-content flex="flex"><md-toolbar ng-hide="$ctrl.$currentProject" style="border-top:1px solid #E0E0E0" md-theme="white" class="md-whiteframe-4dp"><form name="searchForm" class="md-toolbar-tools"><md-button ng-disabled="true" class="md-icon-button"><md-icon>search</md-icon></md-button><input required="required" flex="flex" ng-model="$ctrl.$query" style="background:none;border:none;outline:none" placeholder="Search here..." class="md-body-1"/><md-button ng-show="$ctrl.$query" ng-click="$ctrl.$query = \'\'" class="md-icon-button"><md-icon>close</md-icon></md-button></form></md-toolbar><div ng-hide="$ctrl.$query" ng-if="!$ctrl.$currentProject &amp;&amp; $ctrl.$projects.length"><div style="padding:1rem"><div class="md-headline">Grand total<br/><br/></div><div style="padding:1rem 0" layout="row" layout-align="end"><div ng-if="$ctrl.$timeSelected &gt; 1 &amp;&amp; $ctrl.$loaded" flex="33" style="margin-left:1rem" layout="column" layout-align="start end"> <div style="text-align:right" class="md-caption md-hue-2">DAILY AVERAGE (5 DAYS/WEEK)</div><div style="font-weight:300" class="md-headline">{{($ctrl.$idleTime + $ctrl.$sumTimes($ctrl.$projects)) / ($ctrl.$timeSelected * 5 / 7) | chrono}}</div></div></div><div style="padding:1rem 0" layout="row" layout-align="end"><div flex="33" style="margin-left:1rem" layout="column" layout-align="start end"> <div class="md-caption md-hue-2">IDLE TIME</div><div style="font-weight:300" class="md-headline">{{$ctrl.$idleTime | chrono}}</div></div><div flex="33" style="margin-left:1rem" layout="column" layout-align="start end"><div class="md-caption md-hue-2">WORK TIME</div><div style="font-weight:300" class="md-headline">{{$ctrl.$sumTimes($ctrl.$projects) | chrono}}</div></div></div><div layout="row" layout-align="end"><div flex="33" style="margin-left:1rem" layout="column" layout-align="start end"> <div class="md-caption md-hue-2">PRODUCTIVITY</div><div style="font-weight:300" class="md-headline">{{100 * $ctrl.$sumTimes($ctrl.$projects) / ($ctrl.$idleTime + $ctrl.$sumTimes($ctrl.$projects)) | number : 0}}%    </div></div><div flex="33" style="margin-left:1rem" layout="column" layout-align="start end"> <div class="md-caption md-hue-2">TOTAL TIME</div><div style="font-weight:300" class="md-headline">{{$ctrl.$idleTime + $ctrl.$sumTimes($ctrl.$projects) | chrono}}</div></div></div></div><md-divider></md-divider></div><div ng-if="$ctrl.$projects.length &amp;&amp; project.time" ng-show="!$ctrl.$currentProject" ng-repeat="project in $ctrl.$projects | orderBy: \'time\' : true | filter: $ctrl.$query"><div ng-click="$ctrl.$changeProject(project.projectId)" md-ink-ripple="" style="padding:1rem;position:relative;outline:none" layout="row"><div flex="flex" class="md-title">{{project.projectId}}</div><div style="font-weight:300" class="md-title">{{project.time | chrono}}</div></div><md-divider></md-divider></div><root-detail ng-if="$ctrl.$currentProject &amp;&amp; $ctrl.$loaded" ng-init="$ctrl.$projectHits = $ctrl.$getProjectHits($ctrl.$currentProject, $ctrl.$hits)" project-time="$ctrl.$projectTimes[$ctrl.$currentProject]" project-id="$ctrl.$currentProject" project-hits="$ctrl.$projectHits"></root-detail><div style="height: 50vh; width: 99vw" layout="column" layout-align="end center" class="margin padding"><div class="md-caption container-half">&copy; Daniel Ángel 2017. All Rights Reserved.<br/>This information is completely confidential and should not be shared without previous authorization from Daniel Ángel<br/>danyelangel@hotmail.com</div></div></md-content></div>');
}]);

'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($filter) {
      _classCallCheck(this, Controller);

      this.$filter = $filter;
    }

    _createClass(Controller, [{
      key: '$onChanges',
      value: function $onChanges() {
        this.$setHits(this.projectHits);
      }
    }, {
      key: '$setHits',
      value: function $setHits(hits) {
        var _this = this;

        var previousTimestamps = {},
            entityTimes = {};
        this.$entities = [];
        angular.forEach(hits, function (hit) {
          /* eslint-disable */
          /* jshint ignore:start */
          hit.isWrite = hit.is_write;
          /* eslint-disable */
          /* jshint ignore:end */
          if (!previousTimestamps[hit.entity]) {
            previousTimestamps[hit.entity] = hit.timestamp;
            entityTimes[hit.entity] = 0;
          } else if (hit.timestamp - previousTimestamps[hit.entity] <= 10 * 60 * 1000 && !hit.isWrite) {
            entityTimes[hit.entity] += hit.timestamp - previousTimestamps[hit.entity];
          } else if (hit.isWrite) {
            entityTimes[hit.entity] += hit.timestamp - previousTimestamps[hit.entity];
          }
          previousTimestamps[hit.entity] = hit.timestamp;
        });
        angular.forEach(entityTimes, function (time, entity) {
          _this.$entities.push({
            entity: entity,
            filename: _this.$entityFilename(entity),
            path: _this.$entityPath(entity),
            time: time
          });
        });
      }
    }, {
      key: '$sumTimes',
      value: function $sumTimes(query, array) {
        var total = 0;
        angular.forEach(this.$filter('filter')(array, query), function (item) {
          total += item.time;
        });
        return total;
      }
    }, {
      key: '$entityPath',
      value: function $entityPath(entity) {
        var array = this.entityArray(entity);
        array.pop();
        return array.join('/');
      }
    }, {
      key: '$entityFilename',
      value: function $entityFilename(entity) {
        return this.entityArray(entity).pop();
      }
    }, {
      key: 'entityArray',
      value: function entityArray(entity) {
        return this.cleanEntity(entity).split('/');
      }
    }, {
      key: 'cleanEntity',
      value: function cleanEntity(entity) {
        return entity.replace(entity.substr(0, entity.indexOf('/dev/' + this.projectId + '/') + 6 + this.projectId.length), '');
      }
    }]);

    return Controller;
  })();

  angular.module('root.detail', []).component('rootDetail', {
    controller: Controller,
    templateUrl: 'root/detail/detail-root.html',
    bindings: {
      projectTime: '<',
      projectId: '<',
      projectHits: '<'
    }
  }).config(function ($stateProvider) {
    $stateProvider.state('root.detail', {
      abstract: false,
      url: '/detail/:projectId',
      template: ''
    });
  });
})();
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

(function () {
  'use strict';

  var Controller = (function () {
    function Controller($state, $firedux, $timeout) {
      _classCallCheck(this, Controller);

      this.workMinutes = 10;
      this.idleMinutes = 30;
      this.$timeout = $timeout;
      this.$firedux = $firedux;
      this.$state = $state;
    }

    _createClass(Controller, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        this.$changeTime(0.333);
        this.$firedux.val('time').watch(function (time) {
          _this.$updateTimes(time);
        });
      }
    }, {
      key: '$setHits',
      value: function $setHits(hits) {
        var _this2 = this;

        var previousTimestamps = {},
            previousTimestamp = undefined,
            idleTime = 0,
            projectTimes = {};
        this.$projects = [];
        angular.forEach(hits, function (hit) {
          /* eslint-disable */
          /* jshint ignore:start */
          hit.isWrite = hit.is_write;
          /* eslint-disable */
          /* jshint ignore:end */
          if (!previousTimestamps[hit.project]) {
            previousTimestamps[hit.project] = hit.timestamp;
            previousTimestamp = hit.timestamp;
            projectTimes[hit.project] = 0;
          } else if (hit.timestamp - previousTimestamps[hit.project] <= _this2.workMinutes * 60 * 1000) {
            projectTimes[hit.project] += hit.timestamp - previousTimestamps[hit.project];
          } else if (hit.timestamp - previousTimestamps[hit.project] > _this2.workMinutes * 60 * 1000 && hit.timestamp - previousTimestamps[hit.project] < _this2.idleMinutes * 60 * 1000) {
            idleTime += hit.timestamp - previousTimestamp;
          } else if (hit.isWrite) {
            projectTimes[hit.project] += hit.timestamp - previousTimestamps[hit.project];
          }
          previousTimestamps[hit.project] = hit.timestamp;
          previousTimestamp = hit.timestamp;
        });
        angular.forEach(projectTimes, function (time, projectId) {
          _this2.$projects.push({
            projectId: projectId,
            time: time
          });
        });
        this.$idleTime = idleTime;
        this.$projectTimes = projectTimes;
      }
    }, {
      key: '$sumTimes',
      value: function $sumTimes(projects) {
        var total = 0;
        angular.forEach(projects, function (project) {
          total += project.time;
        });
        return total;
      }
    }, {
      key: '$getProjectHits',
      value: function $getProjectHits(projectId, hits) {
        var projectHits = [];
        angular.forEach(hits, function (hit) {
          if (hit.project === projectId) {
            projectHits.push(hit);
          }
        });
        return projectHits;
      }
    }, {
      key: '$changeTime',
      value: function $changeTime(time) {
        this.$firedux.val('time').set(time);
        this.$autoRefresh = time <= 1 ? true : false;
      }
    }, {
      key: '$updateTimes',
      value: function $updateTimes(time) {
        this.startTime = Date.now() - time * 24 * 3600 * 1000;
        this.$loaded = false;
      }
    }, {
      key: '$changeProject',
      value: function $changeProject(projectId) {
        if (projectId) {
          this.$state.go('root.detail', {
            projectId: projectId
          });
          this.$loaded = false;
          this.$autoRefresh = false;
        } else {
          this.$state.go('root');
          this.$loaded = false;
          this.$autoRefresh = false;
        }
      }
    }]);

    return Controller;
  })();

  angular.module('root', ['root.detail']).component('rootEl', {
    controller: Controller,
    templateUrl: 'root/root.html'
  }).config(function ($stateProvider) {
    $stateProvider.state('root', {
      abstract: false,
      url: '/root',
      template: '<root-el/>'
    });
  });
})();
'use strict';

(function () {
  'use strict';
  function config($mdThemingProvider) {
    $mdThemingProvider.theme('default').primaryPalette('blue', {
      'default': '500'
    }).accentPalette('amber', {
      'default': '500'
    });
    $mdThemingProvider.theme('white').primaryPalette('grey', {
      'default': '50'
    }).accentPalette('blue', {
      'default': '500'
    }).backgroundPalette('grey', {
      'default': '100'
    });
  }
  angular.module('app.themes', []).config(config);
})();
'use strict';

(function () {
  'use strict';

  angular.module('app.routes', ['ui.router']).config(config);

  function config($urlRouterProvider) {
    $urlRouterProvider.otherwise('/root');
  }
})();
'use strict';

(function () {
  'use strict';
  angular.module('app.firedux', []).run(run);
  function run($firedux) {
    var config = {
      apiKey: 'AIzaSyDEc5ANSFNlg2iNyYW7nfwhwMTaEEhepoM',
      authDomain: 'timetracker-ecd54.firebaseapp.com',
      databaseURL: 'https://timetracker-ecd54.firebaseio.com',
      storageBucket: 'timetracker-ecd54.appspot.com'
    };
    $firedux.init(config);
  }
})();
'use strict';

(function () {
  'use strict';
  angular.module('app.filters', []).filter('chrono', function () {
    return function (time) {
      var ms = time % 1000,
          seconds = (time - ms) / 1000,
          secs = seconds % 60,
          minutes = (seconds - secs) / 60,
          mins = minutes % 60,
          hours = (minutes - mins) / 60,

      // hrs = hours % 6,
      // days = (hours - hrs) / 6,
      minsString = mins + 'm ',
          hrsString = hours + 'h ',

      // daysString = days + 'wd ',
      string =
      // (days > 0 ? daysString : '') +
      (hours > 0 ? hrsString : '') + (mins > 0 ? minsString : '');
      return string;
    };
  });
})();